import styles from '../styles.module.css';
import { Fail } from '@tcl-argon-icons/icons';
import { ErrorPalette } from '@tcl-boron-colors/colors';

const NeuroStandaloneFormUnknownError: React.FC<{ referenceId?: string }> = ({ referenceId }) => (
  <div data-testid="neuro-standalone-form-unknown-error" style={{ textAlign: 'center' }}>
    <div className={styles.statusContainer}>
      <Fail color={ErrorPalette[700]} />
      <p className={styles.subtitle} style={{ margin: 0 }}>
        <strong>Unknown Error</strong>
      </p>
    </div>
    <p className={styles.subtitle}>
      There was an unknown error. Please refresh your page and try again. If this issue persists, please contact the
      Tempus Customer Success team at <a href="mailto:help@tempus.com">help@tempus.com</a> or call{' '}
      <a href="tel:312-598-9961">312-598-9961</a>.
    </p>
    {referenceId && (
      <p className={styles.subtitle}>
        Form Reference ID: <strong>{referenceId}</strong>
      </p>
    )}
  </div>
);

export default NeuroStandaloneFormUnknownError;
